import React, { useState, useRef, useEffect } from 'react';
import { HOUSECALL_VIDEO_URL } from '../data/site';
export function BackgroundAudio() {
  const [isMuted, setIsMuted] = useState(true);
  const audioRef = useRef<HTMLAudioElement>(null);
  useEffect(() => {
    // Attempt to play on mount (will likely be blocked by browser until interaction)
    if (audioRef.current && !isMuted) {
      audioRef.current.play().catch(() => {
        // Autoplay blocked, wait for user interaction
        setIsMuted(true);
      });
    }
  }, [isMuted]);
  const toggleMute = () => {
    if (audioRef.current) {
      if (isMuted) {
        audioRef.current.play();
      } else {
        audioRef.current.pause();
      }
      setIsMuted(!isMuted);
    }
  };
  return <>
      <audio ref={audioRef} src={HOUSECALL_VIDEO_URL} loop data-id="element-15" data-mp="6lgswjdn3zey" />
      <button onClick={toggleMute} className="fixed bottom-6 left-6 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-white/10 text-white backdrop-blur-md ring-1 ring-white/20 transition-all hover:bg-white/20 hover:scale-110" aria-label={isMuted ? 'Activar sonido' : 'Silenciar sonido'} data-id="element-16" data-mp="3f1tevfgfq6t5">
        {isMuted ? <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5} data-id="element-17" data-mp="17qr8tleykupx">
            <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 9.75L19.5 12m0 0l2.25 2.25M19.5 12l2.25-2.25M19.5 12l-2.25 2.25m-10.5-6l4.72-4.72a.75.75 0 011.28.531V19.94a.75.75 0 01-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.506-1.938-1.354A9.01 9.01 0 012.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75z" data-id="element-18" data-mp="1hix7tf3mocem" />
          </svg> : <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5} data-id="element-19" data-mp="ts19dz4o2iye">
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.114 5.636a9 9 0 010 12.728M16.463 8.288a5.25 5.25 0 010 7.424M6.75 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.01 9.01 0 012.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75z" data-id="element-20" data-mp="xstjeuld4rvq" />
          </svg>}
      </button>
    </>;
}